import { render } from "./BlFormFieldDate.vue?vue&type=template&id=56f81c06&scoped=true"
import script from "./BlFormFieldDate.vue?vue&type=script&lang=js"
export * from "./BlFormFieldDate.vue?vue&type=script&lang=js"

import "./BlFormFieldDate.vue?vue&type=style&index=0&id=56f81c06&scoped=true&lang=scss"

import exportComponent from "/tmp/ef98a231-0263-404c-a747-c31ac6c86af7/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f81c06"]])

export default __exports__